import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {RolesListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {RolesListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new RolesListItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'description')
	);

	return result;
}

// @note There is no output function since list is read only.